<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AvailableIcons from '@/interfaces/AvailableIcons';

interface Props {
  name: AvailableIcons
}
defineProps<Props>();
</script>

<template>
  <component :is="FontAwesomeIcon" :class="$attrs.class ? null : 'tw-w-auto tw-h-4.5'" :icon="name"
    class="tw-fill-current tw-flex-shrink-0" />
</template>
